<template>
  <div>
    <div class="appSubHeader position-fixed">
      <div class="appSubHeader_content row no-gutters justify-content-between align-items-center mx-auto pt-1">
        <div class="d-flex align-items-center w-100 justify-content-center">
          <p v-if="msgReceivedChannelBryCRC"
             class="appSubHeader_box position-relative mr-2 mr-sm-3 text-bold small"
             :class="{ 'conexion--active': msgReceivedChannelBryCRC.connectionBry && msgReceivedChannelBryCRC.connectionCRC,
                       'conexion--inactive': !msgReceivedChannelBryCRC.connectionBry || !msgReceivedChannelBryCRC.connectionCRC }">
            <button class="appSubHeader_conexao"
                    title="Conexão CRC e Bry"
                    type="button"
                    @click="openModal()">
              Conexão:
              <span v-if="msgReceivedChannelBryCRC.connectionBry && msgReceivedChannelBryCRC.connectionCRC"
                    class="text-success">
                Ativa
              </span>
              <span v-else-if="!msgReceivedChannelBryCRC.connectionBry && !msgReceivedChannelBryCRC.connectionCRC"
                    class="text-danger">
                Inativa
              </span>
              <span v-else
                    class="text-danger">
                Atenção
              </span>
            </button>
          </p>

          <p v-if="$store.state.webSockets.info.qtdTarefasPendentes > 0 || typeof($store.state.webSockets.info.qtdTarefasPendentes) === 'object'"
             class="appSubHeader_box position-relative text-bold text-right small somePend">
            <b-link class="text-dark tooltipDocsPendentes"
                    data-tooltip="Documentos pendentes no gerenciador de tarefas"
                    :to="{ name: 'gerenciador' }">
              Gerenciador de tarefas:

              <span class="text-danger">
                {{ $store.state.webSockets.info.qtdTarefasPendentes || 'N/D' }}
              </span>
            </b-link>
          </p>

          <p v-if="$store.state.webSockets.info.qtdTarefasPendentes === 0"
             class="appSubHeader_box position-relative text-bold text-right small noPend">
            <b-link :to="{ name: 'gerenciador' }">
              <span class="text-dark">
                Documentos Prontos
              </span>
            </b-link>
          </p>

          <p v-if="status"
             :class="verificandoQuantidadeDeSelos() ? 'appSubHeader_box position-relative pl-2 mt-0 migracao': 'appSubHeader_box position-relative pl-2 mt-0 migracao notUseSeparateBorder'"
             @click="showMigracao = true">
            <b-link class="text-dark">
              <div v-if="status && status !== 'COMPLETED'">
                <span v-if="status === 'FAILED' && 2 < 1">
                  <IconSvg icon="cloudSyncRed"
                           class="icon--sm iconBlue" />
                </span>
                <span v-else>
                  <IconSvg icon="cloudSync"
                           class="icon--sm iconBlueBlink" />
                </span>
                <span :class="textoMigracaoClasse">{{ textoMigracaoStatus }}</span>
              </div>
              <div v-else>
                <IconSvg icon="cloudSyncCheck"
                         class="icon--sm iconBlue" />
                <span :class="textoMigracaoClasse">{{ textoMigracaoStatus }}</span>
              </div>
            </b-link>
          </p>

          <p v-if="osFiltradasPorStatusDosSelos && osFiltradasPorStatusDosSelos.selosDaMesmaOs"
             id="selos_nao_enviados_ao_tj"
             class="appSubHeader_box position-relative pl-2 mt-0 selosNaoEnviados"
             @click="exibirOsComSelosNaoEnviados">
            <b-link class="text-dark d-flex">
              <div class="exclamation">
                !
              </div>
              <span class="text-bold small">Selos não enviados: <span class="numeroDeSelos">{{ verificandoQuantidadeDeSelos() }}</span></span>
            </b-link>
          </p>

          <p v-else-if="osFiltradasPorStatusDosSelos && !osFiltradasPorStatusDosSelos.selosDaMesmaOs"
             id="selos_nao_enviados"
             class="appSubHeader_box position-relative pl-2 mt-0 selosNaoEnviados"
             @click="exibirOsComSelosNaoEnviados">
            <b-link class="text-dark d-flex"
                    :to="{ name: 'ordens_servicos' }">
              <div class="exclamation">
                !
              </div>
              <span class="text-bold small">Selos não enviados: <span class="numeroDeSelos">{{ verificandoQuantidadeDeSelos() }}</span></span>
            </b-link>
          </p>

          <p class="appSubHeader_box position-relative text-bold text-right small eProtocolo pl-2">
            <b-link class="text-dark"
                    :to="{ name: 'Pendencia' }">
              <span>
                <IconSvg :icon="totalNotificacoes ? 'requerimentoComPendencia' : 'requerimentoSemPendencia'"
                         class="icon--sm" />
              </span>
              Pendência e-Protocolo:

              <span :class="totalNotificacoes ? 'text-danger' : 'text-success'">
                {{ totalNotificacoes }}
              </span>
            </b-link>
          </p>

          <p class="appSubHeader_box position-relative pl-2 mt-0 chatSuporte">
            <b-link class="text-dark"
                    :to="{ name: 'Atendimento' }">
              <span>
                <IconSvg icon="contactSupport"
                         class="icon--sm iconBlue" />
              </span>
              <span class="text-bold small">Fale com nosso suporte</span>
            </b-link>
          </p>

          <b-modal v-if="msgReceivedChannelBryCRC"
                   id="conexaoBryCRCModal"
                   ref="conexaoBryCRCModal"
                   hide-header
                   close-only
                   centered
                   size="lg"
                   @hide="cancelModal()">
            <div class="row col-12 mt-2">
              <div class="col-3">
                <div class="row ml-0 text-certificado">
                  <b>Barramento certificação digital</b>
                </div>
                <div class="row ml-0 mt-1">
                  <span class="btn btn-sm statusLogo"
                        :class="{ 'statusLogoAtivo': msgReceivedChannelBryCRC.connectionBry,
                                  'statusLogoInativo': !msgReceivedChannelBryCRC.connectionBry }">
                    {{ msgReceivedChannelBryCRC.connectionBry ? 'Ativa' : 'Inativa' }}
                  </span>
                </div>
              </div>

              <strong class="col-9 motivo">
                Motivo:
                <div class="row ml-0">
                  {{ msgReceivedChannelBryCRC.connectionBry ? '--' : 'Serviço da Bry está sem conexão.' }}
                </div>
              </strong>
            </div>

            <hr class="lineModalConexao">

            <div class="row col-12">
              <div class="col-3">
                <div class="row ml-0">
                  <img class="crcLogo"
                       alt="Logo CRC"
                       src="@/assets/icons/CRC-logo_principal.svg">
                </div>
                <div class="row ml-0">
                  <span class="btn btn-sm statusLogo"
                        :class="{ 'statusLogoAtivo': msgReceivedChannelBryCRC.connectionCRC,
                                  'statusLogoInativo': !msgReceivedChannelBryCRC.connectionCRC }">
                    {{ msgReceivedChannelBryCRC.connectionCRC ? 'Ativa' : 'Inativa' }}
                  </span>
                </div>
              </div>

              <strong class="col-9 motivo">
                Motivo:
                <div class="row ml-0">
                  {{ msgReceivedChannelBryCRC.connectionCRC ? '--' : 'Serviço da CRC está sem conexão.' }}
                </div>
              </strong>
            </div>

            <div slot="modal-footer"
                 slot-scope="{ cancel }">
              <div class="row no-gutters justify-content-end align-items-center">
                <div>
                  <button class="btn btn-sm cancelConexao mr-2"
                          @click="cancelModal()">
                    Fechar
                  </button>
                </div>
              </div>
            </div>
          </b-modal>
        </div>
      </div>
    </div>
    <Migracao v-if="showMigracao"
              :prop-status="status"
              :prop-text="textoMigracaoStatus"
              @hideModal="showMigracao = false" />
  </div>
</template>

<script>
 /* components */
  import Migracao from "@/components/MigracaoDados"

  /* services */
  import { ws } from "@/services/api"
  import MigracaoService from "@/services/MigracaoService"
  import EProtocoloService from '@/services/EProtocoloService'

  /* others */
  import webSocketClientAdonis from '@adonisjs/websocket-client'
  import { mapGetters } from 'vuex'
  import pegarOsPorStatusDosSelos from "@/constants/pegarOsPorStatusDosSelos"

  export default {
    name: "AppSubHeader",
    components: {
      Migracao
    },
    data () {
      return {
        webSocket: null,
        channelBryCRC: null,
        msgReceivedChannelBryCRC: null,
        status: null,
        textoMigracaoStatus: null,
        textoMigracaoClasse: null,
        showMigracao: false,
        osFiltradasPorStatusDosSelos: null
      }
    },
    computed: {
      ...mapGetters({
        cartorioId: 'auth/getCartorioId',
        primeiroAcesso: 'auth/getCartorioPrimeiroAcesso',
        user: 'auth/getUser',
        contagemDeExibicaoDosSelosNaoEnviados: 'statusDosSelos/getContagemDeExibicaoDosSelosNaoEnviados',
        userCartorios: "auth/getUserCartorios",
        totalNotificacoes: 'eProtocolo/getTotalNotificacoes'
      })
    },
    async mounted () {
      this.connectToWebSocket()

      this.checkMigracao()
      this.osFiltradasPorStatusDosSelos = await pegarOsPorStatusDosSelos('selos_nao_enviados')

      const cns = this.userCartorios[0].cns
      const response = await EProtocoloService.obterNotificacoes(cns)
      this.$store.dispatch('eProtocolo/setTotalNotificacoes', response.data.notificacoes.length)
    },
    methods: {
      async connectToWebSocket () {
        this.webSocket = webSocketClientAdonis(ws.defaults.baseURL).connect()

        this.webSocket.on('open', () => {
          // Conexão Bry e CRC
          this.channelBryCRC = this.webSocket.getSubscription('conexaoBryCRC')

          if (!this.channelBryCRC) {
            this.subscribeWebSocketChannelBryCRC()
          }
        })
      },
      subscribeWebSocketChannelBryCRC () {
        // Se inscreve no canal
        this.channelBryCRC = this.webSocket.subscribe('conexaoBryCRC')

        // Emit 'message' para receber o status da conexão
        this.channelBryCRC.on('ready', () => this.channelBryCRC.emit('message', ''))

        // Recebe o status da conexão
        this.channelBryCRC.on('message', (message) => this.msgReceivedChannelBryCRC = message)
      },
      openModal () {
        this.$refs.conexaoBryCRCModal.show()

        // Alteramos o z-index do header, pois sem essa alteração o header fica habilitado
        const headerSofia = document.getElementById('header')

        if (headerSofia) {
          headerSofia.style.zIndex = 90
        }
      },
      cancelModal () {
        this.$root.$emit('bv::hide::modal', 'conexaoBryCRCModal')

        // Voltamos o z-index do header ao fechar o modal
        const headerSofia = document.getElementById('header')

        if (headerSofia) {
          headerSofia.style.zIndex = 100
        }
      },
      async checkMigracao () {
        this.textoMigracaoClasse = 'text-bold small position-relative pl-2 mt-0 migracao iconBlue'

        try {
          if (!this.cartorioId) throw "sem id do cartorio"

          const migracao = await MigracaoService.getMigracaoByCartorio(this.cartorioId ? this.cartorioId : this.user.cartorio_id)

          this.status = migracao.status

          if (migracao.status === 'COMPLETED') {
            this.textoMigracaoStatus = 'Migração realizada'
          } else {
            this.textoMigracaoClasse = 'text-bold small position-relative pl-2 mt-0 migracao iconBlueBlink'

            switch (migracao.status) {
            case 'PENDING':
            case 'REQUESTING':
              this.textoMigracaoStatus = 'Solicitando migração'
              break
            case 'PROCESSING':
              this.textoMigracaoStatus = 'Aguardando processamento do Delta'
              break
            case 'PENDING_PROCESS_MONGO':
            case 'PROCESSING_MONGO':
              this.textoMigracaoStatus = 'Salvando dados'
              break
            case 'FAILED':
              // const texto = 'Falha ao realizar migração'
              const texto = 'Solicitando migração'

              this.textoMigracaoStatus = texto
              this.textoMigracaoClasse = 'text-bold small position-relative pl-2 mt-0 migracao iconBlue'

              // throw texto
            }

            setTimeout(() => {
              this.checkMigracao()
            }, 300000)
          }
        } catch (e) {
          this.status = 'FAILED'

          console.error(e)
        }
      },
      exibirOsComSelosNaoEnviados () {
        this.$store
          .dispatch('statusDosSelos/setSelosNaoEnviados', true)
          .then(res => res)

        this.$store
          .dispatch('statusDosSelos/setContagemDeExibicaoDosSelosNaoEnviados', 1)
          .then(res => res)

        if (this.osFiltradasPorStatusDosSelos.selosDaMesmaOs) this.$router.push(`/ordem-servico/${this.osFiltradasPorStatusDosSelos.ordemServicoId}`)
      },
      verificandoQuantidadeDeSelos () {
        return this.osFiltradasPorStatusDosSelos && this.osFiltradasPorStatusDosSelos.somaDosSelosDasOs
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '@/scss/_utilities/_exports';

  /deep/ .modal-footer {
    border-top: 0;
  }

  .cancelConexao {
    background-color: #c4c4c4 !important;
    padding-left: 20px !important;
    padding-right: 20px !important;
  }

  .bryLogo {
    height: 25px;
  }

  .crcLogo {
    height: 78px;
  }

  .statusLogoAtivo {
    background-color: #145c3c !important;
  }

  .statusLogoInativo {
    background-color: #940404 !important;
  }

  .statusLogo {
    color: white !important;
    padding: 0.15rem 0.5rem !important;
    line-height: 15px !important;
    height: 19px;
    pointer-events: none;
  }

  .lineModalConexao {
    background-color: grey;
    margin-left: 15px;
    margin-right: 15px;
  }

  .motivo {
    color:#6c6c6c;
  }

  .text-certificado {
    font-size: 18px;
  }

  .appSubHeader {
    background-color: $color-light-gray;
    color: $color-dark;
    height: pxToRem(70);
    left: 0;
    right: 0;
    transition: top .32s linear;
    top: pxToRem(64);
    z-index: 90;
    width: 97.1%;

    &_content {
      height: 100%;
      max-width: 100% !important;
    }

    &_box {
      margin-bottom: pxToRem(4);
      padding-left: pxToRem(24);
      padding-right: pxToRem(8);

      &:before {
        content: url('../assets/icons/cloud-download.svg');
        bottom: 0;
        height: pxToRem(20);
        left: pxToRem(-4);
        position: absolute;
        top: 0;
        width: pxToRem(20);
      }

      &:not(:last-child) {
        border-right: pxToRem(1) solid $color-logo;
        padding-right: pxToRem(12);
      }

      &.conexion--active {
        &:before {
          content: url('../assets/icons/lan-connect-ok.svg');
        }
      }

      &.conexion--inactive {
        &:before {
          content: url('../assets/icons/lan-disconnect-red.svg');
        }
      }

      &.noPend {
        &:before {
          content: url('../assets/icons/file-document-box-multiple-green.svg');
        }
      }

      &.somePend {
        &:before {
          content: url('../assets/icons/file-document-box-multiple-red.svg');
        }
      }

      &.chatSuporte {
        &:before {
          content: none;
        }
      }

      &.migracao {
        &:before {
          content: none;
        }
      }

      &.selosNaoEnviados {
        &:before {
          content: none;
        }
      }

      &.eProtocolo {
        &:before {
          content: none;
        }
      }
    }

    &_box:last-of-type {
      border-right: none;
    }

    &_conexao {
      background-color: transparent;
      border: none;
      cursor: pointer;
      padding: 0;

      &_text {
        font-size: pxToRem(12);
        font-weight: 500;
      }
    }

    @media(min-width: pxToRem(640)) {
      height: pxToRem(30);
      top: pxToRem(70);
    }

    @media(min-width: pxToRem(568)) {
      &_content {
        max-width: pxToRem(768);
      }
    }

    @media(min-width: pxToRem(1024)) {
      &_content {
        max-width: pxToRem(886);
      }
    }

    @media print {
      display: none;
    }
  }

  .notUseSeparateBorder {
    border-right: 0 !important;
  }

  .iconBlue {
    fill: #074f7f !important;
  }

  .iconBlueBlink {
    fill: #074f7f !important;
    animation: blinker 1s linear infinite;
  }

  .blink_me {
    animation: blinker 1s linear infinite;
  }

  @keyframes blinker {
    50% { opacity: 0; }
  }

  .chatSuporte {
    cursor: pointer;
  }

  .migracao {
    cursor: pointer;
  }

  .exclamation {
    display: inline-block;
    background-color: #8B0000;
    color: #ffffff;
    font-weight: bolder;
    padding: 0px 8px 0px 8px;
    border-radius: 4px;
    margin-right: 7px;
    height: 20px;
  }
  .numeroDeSelos {
    color: #8B0000;
  }

  .chatSuporte:hover .small {
    text-decoration: underline;
  }

  .migracao:hover .small {
    text-decoration: underline;
  }

  .tooltipDocsPendentes::before,
  .tooltipDocsPendentes::after {
    --scale: 0;
    --tooltip-color: #F9F9F9;
    --tooltip-color-border: rgba(0,0,0,.3);
    position: absolute;
    z-index: 1;
    content: '';
    bottom: -1rem;
    transition: 35ms;
    transform: translateX(-10%) translateY(100%) scale(var(--scale));
  }

  .tooltipDocsPendentes::before {
    content: attr(data-tooltip);
    padding: .5rem;
    width: 91%;
    color: black;
    border-radius: .7rem;
    text-align: left;
    background: var(--tooltip-color);
    box-shadow: inset 0 0 0.1em var(--tooltip-color-border);
    -webkit-filter: drop-shadow(1px 1px 1px var(--tooltip-color-border));
    filter: drop-shadow(1px 1px 1px var(--tooltip-color-border));
  }

  .tooltipDocsPendentes:hover::before,
  .tooltipDocsPendentes:hover::after {
    --scale: 1;
  }

  .tooltipDocsPendentes:after {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    border: solid;
    box-shadow: 0px 10px 20px 10;
    border-width: 0px 10px 20px 10px;
    transform: translateX(-460%) translateY(5%) scale(var(--scale));
    border-color: transparent transparent var(--tooltip-color) transparent;
    -webkit-filter: drop-shadow(1px 0px 0px var(--tooltip-color-border));
    filter: drop-shadow(1px 0px 0px var(--tooltip-color-border));
  }


</style>
